import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck, faTriangleExclamation, faCircleExclamation, faCircleInfo } from "@fortawesome/free-solid-svg-icons"

export const MessageModal = ({visible, setVisible, type, message, title=undefined}) => {
  let defaultTypes = {
    success: {title: title? title:'Success', icon: <FontAwesomeIcon icon={faCircleCheck} />, color: '#28a745'},
    error: {title: title? title:'Error', icon: <FontAwesomeIcon icon={faTriangleExclamation} />, color: '#dc3545' },
    warning: {title: title? title:'Warning', icon: <FontAwesomeIcon icon={faCircleExclamation} />, color: '#ffc107'},
    info: {title: title? title:'Information', icon: <FontAwesomeIcon icon={faCircleInfo} />, color: '#17a2b8'}
  }

  const handleHideModal = () => {setVisible(false)}

  return (
    <div className="modal_bkg" style={visible? {}:{display: 'none'}}>
      <div className="modal_body">
        <span className="modal_title" style={{color: defaultTypes[type]? defaultTypes[type].color:defaultTypes['info'].color}}>
          {defaultTypes[type]? defaultTypes[type].icon:defaultTypes['info'].icon}
          {defaultTypes[type]? defaultTypes[type].title:defaultTypes['info'].title}
        </span>
        <div className="modal_sep_line" />
        <span className="modal_message">
          {message}
        </span>
        <div className="modal_buttons">
          <button type="button" onClick={handleHideModal}>OK</button>
        </div>
      </div>
    </div>
  )
}